// export const ViewportWidth = 750;
export const ViewportWidth = 375;

export function px2vw(
  pxValue: string | number | undefined | null
): string | number {
  if (pxValue === undefined || pxValue === null) {
    return 0;
  }
  let px;
  if (typeof pxValue === "string") {
    px = parseInt(pxValue.slice(0, -2));
    return ((px / ViewportWidth) * 100).toFixed(5) + "vw";
  } else if (typeof pxValue === "number") {
    px = pxValue;
    return ((px / ViewportWidth) * 100).toFixed(5);
  } else {
    console.log("Invalid input type for function px2vw");
    return 0;
  }
}

export function vw2px(
  vwValue: string | number | undefined | null
): string | number {
  if (vwValue === undefined || vwValue === null) {
    return 0;
  }
  let vw;
  if (typeof vwValue === "string") {
    vw = parseFloat(vwValue.slice(0, -2));
    return ((vw / 100) * ViewportWidth).toFixed(5) + "px";
  } else if (typeof vwValue === "number") {
    vw = vwValue;
    return ((vw / 100) * ViewportWidth).toFixed(5);
  } else {
    console.log("Invalid input type for function vw2px");
    return 0;
  }
}

export function dynamicPx(pxValue: number): number {
  const deviceWidth = window.innerWidth; // 获取当前设备的实际宽度
  const scale = deviceWidth / ViewportWidth; // 计算比例
  return pxValue * scale; // 根据比例计算出动态的 px 值
}
